import Confirm from './ConfirmRegistration'

export default Confirm
